export default "__VITE_ASSET__B$G6Ps8Z__"